import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import PageHero from '../components/PageHero';
import Certifications from '../components/Certifications';

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const CertificationsPage = () => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{ duration: 0.35 }}>
    <PageHero
      title="Certifications &"
      highlight="Achievements"
      subtitle="Professional certifications validating my expertise in QA, DevOps, CI/CD, AI testing, and agile methodologies."
      pattern="dots"
    />
    <Certifications hideTitle />
    {/* CTA */}
    <section className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
      <div className="container-custom text-center">
        <p className="text-secondary-600 dark:text-gray-100 mb-4">See these skills applied in real projects.</p>
        <Link to="/projects" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors">
          View Projects <FiArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </motion.div>
);

export default CertificationsPage;
